export const PEAK_FLOW_ZHAO_2021_REFERENCE_AGE_MIN = 40;
export const PEAK_FLOW_ZHAO_2021_REFERENCE_AGE_MAX = 85;
export const PEAK_FLOW_ZHAO_2021_REFERENCE_AGE_STEP = 0.25;

export const PEAK_FLOW_ZHAO_2021_MALE_MSPLINE: number[] = [
  -1.58721732645972e-6,
  -1.56149934582572e-6,
  -1.53578135098087e-6,
  -1.51006331350345e-6,
  -1.48434534708031e-6,
  -1.4586273380246e-6,
  -1.43290937160145e-6,
  -1.40719134833489e-6,
  -1.38147333927918e-6,
  -1.35575537285604e-6,
  -1.33003736380033e-6,
  -1.30431934053377e-6,
  -1.27860135989977e-6,
  -1.25288352137432e-6,
  -1.22716663497613e-6,
  -1.20145163862162e-6,
  -1.17573948443805e-6,
  -1.15003120981783e-6,
  -1.12432790899675e-6,
  -1.09863091779516e-6,
  -1.07294140150316e-6,
  -1.04726147753809e-6,
  -1.02159668813329e-6,
  -9.959534565950889e-7,
  -9.70338206229826e-7,
  -9.44757175602717e-7,
  -9.19216006423085e-7,
  -8.93720169869994e-7,
  -8.68275037646526e-7,
  -8.42887004637305e-7,
  -8.17566132127467e-7,
  -7.923232203665979e-7,
  -7.67169240134535e-7,
  -7.42115247476249e-7,
  -7.17173463726795e-7,
  -6.923562239080641e-7,
  -6.67675806198531e-7,
  -6.43143948764191e-7,
  -6.18770002347446e-7,
  -5.94562493461126e-7,
  -5.70530090726606e-7,
  -5.4668115012646e-7,
  -5.23022350762403e-7,
  -4.99560059097348e-7,
  -4.76300584750788e-7,
  -4.53250237342218e-7,
  -4.30415070695744e-7,
  -4.07800968105221e-7,
  -3.85414125503303e-7,
  -3.63259715641107e-7,
  -3.41341518605986e-7,
  -3.19662518677433e-7,
  -2.98225813821773e-7,
  -2.77034445161917e-7,
  -2.56091908568123e-7,
  -2.35401699910653e-7,
  -2.14967343481476e-7,
  -1.94791994090338e-7,
  -1.74876447545103e-7,
  -1.5522127227996e-7,
  -1.3582689462055e-7,
  -1.16693740892515e-7,
  -9.78218395175645e-8,
  -7.921124733911709e-8,
  -6.08618222486257e-8,
  -4.27741611019883e-8,
  -2.49505092142499e-8,
  -7.39370875635359e-9,
  9.89345494417648e-9,
  2.69079691861407e-8,
  4.36455991348339e-8,
  6.01018257384567e-8,
  7.627204468008129e-8,
  9.21520779684215e-8,
  1.07739424493047e-7,
  1.23031668408657e-7,
  1.38026592821916e-7,
  1.52722407165129e-7,
  1.67119367233681e-7,
  1.81218297257146e-7,
  1.95019993043388e-7,
  2.08525193556852e-7,
  2.21734239858051e-7,
  2.34647359320661e-7,
  2.47264949848613e-7,
  2.59587295659003e-7,
  2.71615164137984e-7,
  2.83349265828292e-7,
  2.94790424959501e-7,
  3.05939352074347e-7,
  3.1679701351095e-7,
  3.27364091390336e-7,
  3.3764138152037e-7,
  3.47629622865497e-7,
  3.5732915648623e-7,
  3.66740493973339e-7,
  3.75863919543917e-7,
  3.84699859523607e-7,
  3.93248626551213e-7,
  4.01510504843827e-7,
  4.09486005992221e-7,
  4.17175243683232e-7,
  4.24578388447117e-7,
  4.31695497127293e-7,
  4.38526598145472e-7,
  4.45071776766781e-7,
  4.51330578243869e-7,
  4.57302604672805e-7,
  4.62987259197689e-7,
  4.68384257601429e-7,
  4.73493713570861e-7,
  4.78316167118464e-7,
  4.82851874039625e-7,
  4.87101715407334e-7,
  4.91068874453049e-7,
  4.94757045998995e-7,
  4.98169896445688e-7,
  5.01311035350227e-7,
  5.04183674365777e-7,
  5.06790883036956e-7,
  5.09135702486674e-7,
  5.11221884380575e-7,
  5.13055454121059e-7,
  5.14642863436165e-7,
  5.15990706162484e-7,
  5.17105547714891e-7,
  5.1799426614707e-7,
  5.18663540560738e-7,
  5.19120163744446e-7,
  5.1937098533017e-7,
  5.19422826528171e-7,
  5.19282821187517e-7,
  5.18957904205308e-7,
  5.18455124165484e-7,
  5.17781757025659e-7,
  5.169451355868661e-7,
  5.15952535806719e-7,
  5.14811404173088e-7,
  5.13528334522562e-7,
  5.121100912219841e-7,
  5.1056349548162e-7,
  5.08894856920961e-7,
  5.07110087255569e-7,
  5.05214472923399e-7,
  5.03213641422917e-7,
  5.01112879192078e-7,
  4.98917813729349e-7,
  4.96634299906873e-7,
  4.94267737849441e-7,
  4.91823641368683e-7,
  4.89306216877594e-7,
  4.86719386572076e-7,
  4.8406712949145e-7,
  4.81353424675035e-7,
  4.7858236484899e-7,
  4.75758156426309e-7,
  4.72884835289733e-7,
  4.69966437322e-7,
  4.67006373128243e-7,
  4.64007882783335e-7,
  4.60974035831896e-7,
  4.579080723488e-7,
  4.54812948191829e-7,
  4.51691732905601e-7,
  4.48547382347897e-7,
  4.45382852376497e-7,
  4.42200985162344e-7,
  4.39004452346126e-7,
  4.35796209785622e-7,
  4.32578929121519e-7,
  4.29355509368179e-7,
  4.26128735853126e-7,
  4.22901337060466e-7,
  4.19676155161142e-7,
  4.16455520735326e-7,
  4.1324187805003e-7,
  4.10037557685428e-7,
  4.06844549161178e-7,
  4.03663023007539e-7,
  4.00492751850834e-7,
  3.97333451473969e-7,
];

export const PEAK_FLOW_ZHAO_2021_FEMALE_MSPLINE: number[] = [
  -27.0593601922421,
  -26.1759242947028,
  -25.2928843373022,
  -24.4106362601788,
  -23.5295760034713,
  -22.6500542467875,
  -21.7722406276117,
  -20.8962595228972,
  -20.0222353095976,
  -19.1503194100102,
  -18.2807714278078,
  -17.4138780120073,
  -16.5499258116256,
  -15.6892010232235,
  -14.8319880335384,
  -13.9785707768518,
  -13.1292331874451,
  -12.2842630845869,
  -11.4439638274935,
  -10.6086426603684,
  -9.778606827415061,
  -8.95430692555848,
  -8.136766962610009,
  -7.32715429910269,
  -6.52663629556947,
  -5.73637823675034,
  -4.95753710421343,
  -4.19126780373384,
  -3.43872524108666,
  -2.7010594053415,
  -1.97940061874554,
  -1.27487428684054,
  -0.588605815168137,
  0.0783043547449864,
  0.724855637432654,
  1.3500724114437,
  1.95297905532699,
  2.53257920563358,
  3.08779353092311,
  3.61752195775742,
  4.12066441269828,
  4.59620761838117,
  5.04348548173617,
  5.46191870576705,
  5.85092799347751,
  6.21001981655371,
  6.53904372141123,
  6.83793502314815,
  7.10662903686244,
  7.34501839710592,
  7.55282501624545,
  7.72972812610165,
  7.87540695849505,
  7.98973935476725,
  8.07339759434389,
  8.127252566171521,
  8.152175159196791,
  8.149088208409109,
  8.1191223329692,
  8.06346009808065,
  7.98328406894706,
  7.87976203590529,
  7.7540026898257,
  7.60709994671191,
  7.44014772256749,
  7.25419055520027,
  7.05007546963471,
  6.82860011269949,
  6.59056213122325,
  6.33674590328154,
  6.06788273193708,
  5.78469065149955,
  5.48788769627856,
  5.17824372525905,
  4.85673589612709,
  4.52439319124416,
  4.18224459297157,
  3.83146097923586,
  3.47378081022414,
  3.11108444168863,
  2.74525222938152,
  2.37817643533877,
  2.0117969467307,
  1.64806555701141,
  1.28893405963494,
  0.936199838277574,
  0.59104263750443,
  0.254487792102864,
  -0.072439363139793,
  -0.388873600122693,
  -0.694590117491146,
  -0.989524220576939,
  -1.27361121471189,
  -1.54674159081262,
  -1.80862658213493,
  -2.05893260751951,
  -2.29732608580696,
  -2.52356301213052,
  -2.7377576867937,
  -2.94011398639259,
  -3.1308357875233,
  -3.31014866327794,
  -3.47836497273275,
  -3.63581877145998,
  -3.78284411503189,
  -3.91976939543235,
  -4.04690035029178,
  -4.1645370536522,
  -4.27297957955562,
  -4.37249558197277,
  -4.46322303458889,
  -4.54526749101795,
  -4.61873450487386,
  -4.6837260404192,
  -4.74032970451084,
  -4.78862951465433,
  -4.82870948835516,
  -4.86066640280252,
  -4.88464807392026,
  -4.90081507731598,
  -4.90932798859716,
  -4.91039004708007,
  -4.90437514691583,
  -4.89169984596434,
  -4.87278070208542,
  -4.84802780643075,
  -4.81782538331865,
  -4.78255119035924,
  -4.74258298516261,
  -4.69830280744779,
  -4.65010982536904,
  -4.5984074891897,
  -4.54359924917293,
  -4.48608926814023,
  -4.42628455914664,
  -4.36459284780534,
  -4.30142185972966,
  -4.23718380235192,
  -4.17230881038057,
  -4.10723150034303,
  -4.04238648876685,
  -3.97817455278476,
  -3.91486111195078,
  -3.85267774642438,
  -3.79185603636486,
  -3.73261596345245,
  -3.67513111545102,
  -3.6195634816454,
  -3.56607505132038,
  -3.5148322356842,
  -3.46601913363861,
  -3.41982426600896,
  -3.3764361536204,
  -3.33589072619324,
  -3.29761354902774,
  -3.26087759631932,
  -3.22495584226328,
  -3.18911532978444,
  -3.15259937672548,
  -3.11464536965869,
  -3.07449069515627,
  -3.03138941323422,
  -2.98466227768378,
  -2.93364671573991,
  -2.87768015463757,
  -2.81616510395773,
  -2.74876440266519,
  -2.67520597207067,
  -2.59521773348513,
  -2.50850887285375,
  -2.41471363465979,
  -2.31344752802087,
  -2.20432606205475,
  -2.08701556274343,
  -1.96138562352616,
  -1.82735665470651,
  -1.6848490665881,
  -1.53383764425544,
  -1.37451467191698,
  -1.20712680856209,
  -1.03192071318028,
];

export const PEAK_FLOW_LEINER_1963_ADULT_AGES: number[] = [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70];

export const PEAK_FLOW_LEINER_1963_MALE_HEIGHTS_CM: number[] = [155, 160, 165, 170, 175, 180];
export const PEAK_FLOW_LEINER_1963_MALE_VALUES_L_MIN: number[][] = [
  [564, 583, 601, 620, 639, 657],
  [553, 571, 589, 608, 626, 644],
  [541, 559, 577, 594, 612, 630],
  [530, 547, 565, 582, 599, 617],
  [518, 535, 552, 569, 586, 603],
  [507, 523, 540, 557, 573, 590],
  [494, 511, 527, 543, 560, 576],
  [483, 499, 515, 531, 547, 563],
  [471, 486, 502, 518, 533, 549],
  [460, 475, 490, 505, 520, 536],
  [448, 462, 477, 492, 507, 521],
];

export const PEAK_FLOW_LEINER_1963_FEMALE_HEIGHTS_CM: number[] = [145, 150, 155, 160, 165, 170];
export const PEAK_FLOW_LEINER_1963_FEMALE_VALUES_L_MIN: number[][] = [
  [404, 418, 431, 445, 459, 473],
  [399, 412, 426, 440, 453, 467],
  [394, 407, 421, 434, 447, 461],
  [389, 402, 415, 428, 442, 455],
  [383, 396, 409, 422, 435, 448],
  [378, 391, 404, 417, 430, 442],
  [373, 386, 398, 411, 423, 436],
  [368, 380, 393, 405, 418, 430],
  [363, 375, 387, 399, 411, 424],
  [358, 370, 382, 394, 406, 418],
  [352, 364, 376, 388, 399, 411],
];

export const PEAK_FLOW_POLGAR_1971_CHILD_HEIGHTS_CM: number[] = [
  110, 112, 114, 117, 119, 122, 124, 127, 130, 132, 135, 137, 140, 142, 145, 147, 150, 152, 155, 157, 160, 163, 165,
  168, 170,
];
export const PEAK_FLOW_POLGAR_1971_CHILD_VALUES_L_MIN: number[] = [
  147, 160, 173, 187, 200, 214, 227, 240, 254, 267, 280, 293, 307, 320, 334, 347, 360, 373, 387, 400, 413, 427, 440, 454,
  467,
];
